"use client";

import { useNotification } from "@/lib/hooks/use-notification";
import { Button } from "@/components/catalyst/button";
import type { ActionResult } from "@/app/actions";
import { useTranslations } from "next-intl";
import { useState } from "react";

interface CheckoutBuyButtonProps {
  slug: string;
  isButtonDisabled: boolean;
  datetime?: number;
  action: (slug: string, datetime?: number) => Promise<ActionResult<void>>;
}

export function CheckoutBuyButton(props: CheckoutBuyButtonProps) {
  const { slug, isButtonDisabled, datetime, action } = props;
  const t = useTranslations("CheckoutBuyButton");

  const [isLoading, setIsLoading] = useState(false);
  const { showNotification } = useNotification();

  const handleClick = async () => {
    setIsLoading(true);
    const result = await action(slug, datetime);
    setIsLoading(false);
    if (!result.success) {
      showNotification(result.error, "error");
    }
  };

  return (
    <div className="flex flex-col">
      <Button
        disabled={isButtonDisabled || isLoading}
        onClick={handleClick}
        color="purple"
        data-testid="checkout-buy-button"
      >
        {isLoading ? t("buying") : t("buyNow")}
      </Button>
    </div>
  );
}
